export default __webpack_public_path__ + "static/media/483.fff73b9e.png";